<template>
  <Dialog ref="dialog" :config="dialogBaseConfig">
    <div>
      <el-input class="uiInput" v-model="inputValue" :type="inputType" />
    </div>
  </Dialog>
</template>

<script>
import Dialog from "@/components/public/Dialog.vue";

export default {
  name: "UserFieldEditDialog",
  components: { Dialog },
  data() {
    return {
      field: "",
      inputValue: "",
      inputType: "text",
      dialogBaseConfig: {
        top: "20vh",
        width: "500px",
        title: this.$fanyi("提示"),
        btnTxt: [this.$fanyi("确认"), this.$fanyi("取消")],
      },
    };
  },
  methods: {
    /**
     * @param {'last_name'|'name'|'mark'|'NIF'} field
     * @param {string|number|null|undefined} initialValue
     * @param {{ type?: string }} [options] 例如 NIF 弹层内输入框 type
     */
    open(field, initialValue, options = {}) {
      this.field = field;
      this.inputValue =
        initialValue != null && initialValue !== undefined
          ? String(initialValue)
          : "";
      this.inputType = options.type || "text";

      const titles = {
        last_name: this.$fanyi("修改姓氏"),
        name: this.$fanyi("修改名字"),
        mark: this.$fanyi("修改唛头"),
        NIF: this.$fanyi("修改NIF"),
      };

      return this.$nextTick().then(() =>
        this.$refs.dialog.open(
          "",
          () => {
            this.$emit("confirm", {
              field: this.field,
              value: this.inputValue,
            });
          },
          () => {},
          {
            title: titles[field] || this.$fanyi("提示"),
            width: "500px",
            top: "20vh",
          },
        ),
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/css/mixin.scss";

.uiInput {
  width: 100%;
}
/deep/ .uiInput .el-input__inner {
  height: 40px;
  line-height: 40px;
}
</style>
